import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteRosterItem } from "../../../axios/RosterItem/RosterItemApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const RemoveRosterItemDialog = ({
  onClose,
  onRefresh,
  selectedRosterItem,
  anchorEl,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleRemoveRosterItem = async () => {
    // Tour fake item — không gọi API
    if (
      selectedRosterItem?.rosterItemId === "tour-fake-item" ||
      String(selectedRosterItem?.rosterItemId || "").startsWith("tour-fake")
    ) {
      handleCloseDialog();
      anchorEl?.(null);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        rosterItemId: selectedRosterItem.rosterItemId,
        langId: localStorage.getItem("i18nextLngId"),
      };

      const response = await deleteRosterItem(payload);

      if (response?.data === "") {
        handleCloseDialog();
        toast.success(t("common.content-169"));
        anchorEl?.(null);
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.content-167")}
      subtitle={t("common.content-168")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemoveRosterItem}
    />
  );
};

export default RemoveRosterItemDialog;
